import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IconsModule, ModalModule, UiComponentsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { CmsModule } from '@fcom/cms';
import { ComponentsModule } from '@fcom/common/components';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { CommonBookingComponentsModule } from '@fcom/common-booking';
import { UtilsService } from '@fcom/common-booking/services/utils.service';

import { ManageBookingNotificationsComponent } from './components/notifications/notifications.component';
import { ManageBookingTripComponent } from './components/trip/trip.component';
import { ManageBookingFlightComponent } from './components/flight/flight.component';
import { ManageBookingEmergencyContactModule } from './components/emergency-contact/emergency-contact.module';
import { ManageBookingUnsavedChangesComponent } from './components/unsaved-changes/unsaved-changes.component';
import { InterimCancelBookingModalComponent } from './components/interim-cancel-booking-modal/interim-cancel-booking-modal-component';
import { CancelBookingModalComponent } from './components/cancel-booking-modal/cancel-booking-modal-component';
import { ManageBookingModifyTripComponent } from './components/modify-trip/modify-trip.component';
import { ManageBookingChangeFlightGeneralInfoModalComponent } from './components/change-flight-general-info/change-flight-general-info-modal.component';
import { ManageBookingSelectMatrixComponent } from './components/select-matrix/select-matrix.component';
import { ManageBookingSelectDateComponent } from './components/select-date/select-date.component';
import { ManageBookingSelectBoundComponent } from './components/select-bound/select-bound.component';
import { NotificationsService, OffersService } from '../../services';
import { ThirdPartyLinksComponent } from './components/third-party-links/third-party-links.component';
import { CheckInTriggerComponent } from './components/check-in-trigger/check-in-trigger.component';
import { CarTrawlerWidgetModule } from './components/cartrawler-widget/cartrawler-widget.module';

const COMPONENTS = [
  ThirdPartyLinksComponent,
  ManageBookingNotificationsComponent,
  ManageBookingTripComponent,
  ManageBookingModifyTripComponent,
  ManageBookingFlightComponent,
  ManageBookingUnsavedChangesComponent,
  InterimCancelBookingModalComponent,
  CancelBookingModalComponent,
  ManageBookingChangeFlightGeneralInfoModalComponent,
  ManageBookingSelectMatrixComponent,
  ManageBookingSelectDateComponent,
  ManageBookingSelectBoundComponent,
  CheckInTriggerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    PipesModule,
    GtmModule,
    CmsModule,
    UiTranslateModule,
    UiComponentsModule,
    IconsModule,
    ModalModule,
    CommonBookingComponentsModule,
    ManageBookingEmergencyContactModule,
    ReactiveFormsModule,
    CarTrawlerWidgetModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS, ManageBookingEmergencyContactModule],
  providers: [UtilsService, OffersService, NotificationsService],
})
export class ManageBookingCommonModule {}
